import service from '@/utils/request'; // getShiftList 获取交班列表
// @Tags Shift
// @Summary 获取交班列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /shift/info/getList [get]

export var getShiftList = function getShiftList(params) {
  return service({
    url: '/shift/info/getList',
    method: 'get',
    params: params
  });
}; // getShiftDetail 获取交班明细
// @Tags Shift
// @Summary 获取交班明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /shift/info/detail [get]

export var getShiftDetail = function getShiftDetail(params) {
  return service({
    url: '/shift/info/detail',
    method: 'get',
    params: params
  });
}; // shiftInfoSubmit 交班信息提交
// @Tags Shift
// @Summary 交班信息提交
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shift/info/submit [post]

export var shiftInfoSubmit = function shiftInfoSubmit(data) {
  return service({
    url: '/shift/info/submit',
    method: 'post',
    data: data
  });
};